import { render, staticRenderFns } from "./StepBookingTypesGroups.vue?vue&type=template&id=6909ded4&"
import script from "./StepBookingTypesGroups.vue?vue&type=script&lang=js&"
export * from "./StepBookingTypesGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports